<template>
  <div style="padding: 0.615rem">
    <link
      :href="'/css/resume-register-in-publisher-site.css'"
      rel="stylesheet"
    />
    <div class="soha-submit-resume">
      <div style="padding: 0.615rem">
        <div class="soha-job-card" v-for="(job, key) in jobList" :key="key">
          <div class="soha-job-card-content">
            <div class="soha-job-card-info">
              <div class="soha-job-card-info-title">
                <a
                  class="soha-anchor-tag-style"
                  :href="
                    scv_frontSiteUrl +
                    'jobOpportunity?companyId=' +
                    job.jobCompany.id +
                    '&job=' +
                    job.pivot.jobId
                  "
                  target="_blank"
                >
                  <h2>
                    {{ job.title }}
                  </h2>
                </a>

                <label class="soha-job-category-tag" v-if="job.jobCategory">{{
                  job.jobCategory.name
                }}</label>
              </div>
              <div class="soha-job-specifications">
                <span v-if="job.jobCompany" soha-tooltip="نام شرکت">
                  <img
                    :src="
                      scv_frontSiteUrl + '/media/svg/soha/icons/company.svg'
                    "
                  />{{ job.jobCompany.name }}</span
                >
                <span v-else>
                  <img
                    :src="
                      scv_frontSiteUrl + '/media/svg/soha/icons/company.svg'
                    "
                  />
                  نام شرکت ثبت نشده
                </span>
                <span v-if="job.genderId" soha-tooltip="جنسیت">
                  <img
                    :src="scv_frontSiteUrl + '/media/svg/soha/icons/gender.svg'"
                  />{{ setGenderName(job.genderId) }}</span
                >
                <span v-else>
                  <img
                    :src="scv_frontSiteUrl + '/media/svg/soha/icons/gender.svg'"
                  />
                  جنسیت ثبت نشده
                </span>
                <span v-if="job.city" soha-tooltip="استان و شهر">
                  <img
                    :src="
                      scv_frontSiteUrl + '/media/svg/soha/icons/location.svg'
                    "
                  />{{ job.city.province.name }}-{{ job.city.name }}</span
                >
                <span v-else>
                  <img
                    :src="
                      scv_frontSiteUrl + '/media/svg/soha/icons/location.svg'
                    "
                  />
                  شهر ثبت نشده
                </span>
                <span v-if="job.typeOfCooperation" soha-tooltip="نوع قرارداد">
                  <img
                    :src="scv_frontSiteUrl + '/media/svg/soha/icons/pen.svg'"
                  />{{ job.typeOfCooperation.name }}</span
                >
                <span v-else>
                  <img
                    :src="scv_frontSiteUrl + '/media/svg/soha/icons/pen.svg'"
                  />
                  نوع قرارداد ثبت نشده
                </span>
                <span v-if="job.pivot" soha-tooltip="تاریخ">
                  <img
                    :src="
                      scv_frontSiteUrl + '/media/svg/soha/icons/calendar.svg'
                    "
                  />{{
                    toPersianDigits(
                      `${job.pivot.publishDate
                        .split(" ")[0]
                        .replace("-", "/")
                        .replace("-", "/")}`
                    )
                  }}</span
                >
                <span v-else>
                  <img
                    :src="
                      scv_frontSiteUrl + '/media/svg/soha/icons/calendar.svg'
                    "
                  />
                  تاریخ ثبت نشده
                </span>
              </div>
            </div>
            <div class="soha-job-card-action">
              <a
                class="soha-job-card-btn soha-anchor-tag-style"
                @click="openJobOpportunity(job.pivot.jobId ,job.jobCompany.id)"
                :href="
                  'https://2ndcv.ir/jobOpportunity?companyId=' +
                  job.jobCompany.id +
                  '&job=' +
                  job.pivot.jobId
                "
              >
                فرم درخواست
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="soha-pagination-offset" v-if="pageCount.length > 0">
        <nav>
          <ul class="soha-publisher-pagination">
            <li class="soha-custom-pagination">
              <a
                class="soha-anchor-tag-style"
                :href="updateQueryStringParameter('jobPage', currentPage - 1)"
                @click="onPageChange(currentPage - 1)"
                v-if="currentPage !== 1"
              >
                قبلی
              </a>
            </li>
            <li class="soha-custom-pagination">
              <a
                class="soha-anchor-tag-style"
                :href="updateQueryStringParameter('jobPage', pageNumber)"
                v-for="pageNumber in pageCount.slice(
                  currentPage > 3 && pageCount.length > 5
                    ? currentPage > pageCount.length - 2
                      ? currentPage - 5
                      : currentPage - 3
                    : 0,

                  currentPage < 3
                    ? currentPage + 5 - currentPage
                    : currentPage + 2
                )"
                :key="pageNumber"
                @click="onPageChange(pageNumber)"
                :class="pageNumber === currentPage ? 'soha-selected-page' : ''"
              >
                {{ toPersianDigits(pageNumber) }}
              </a>
            </li>
            <li class="soha-custom-pagination">
              <a
                class="soha-anchor-tag-style"
                :href="updateQueryStringParameter('jobPage', currentPage + 1)"
                v-if="currentPage !== pageCount.length"
                @click="onPageChange(currentPage + 1)"
              >
                بعدی
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <a
        href="https://soha-ats.com/"
        style="color: rgb(41, 49, 86); text-decoration: none !important"
        target="_blank"
      >
        <div style="margin-top: 0.769rem; display: flex; justify-content: center">
          <div>
            <img
              class="soha-powered-logo"
              src="https://ats.soha-hr.ir//media/logos/soha-logo.png"
            />
          </div>
          <div style="margin-right: 0.385rem; margin-top: 5px">
            <p style="margin-bottom: 0">
              <strong>قــدرت گـرفـته از سـهــا</strong>
            </p>
            <p style="margin-bottom: 0">سامانه هوشمند استخدام</p>
          </div>
        </div>
      </a>
    </div>

    <div id="soha-pub" data-publisher="5"></div>
  </div>
</template>
<script>
const scv_siteUrl = "https://api.2ndcv.ir/";
const scv_frontSiteUrl = "https://ats.soha-hr.ir/";
let publisherId = 5;

import UIMixin from "@/mixins/UIMixin";

export default {
  name: "JobOpportunity",
  mixins: [UIMixin],

  data() {
    return {
      publisher: null,
      jobList: null,
      loading: null,
      currentPage: null,
      pageCount: [],
    };
  },

  mounted() {
    const urlQueries = window.location.href.split("?")[1];
    if (urlQueries) {
      let queryList = urlQueries.split("&");
      if (queryList.length > 0) {
        for (let i = 0; i < queryList.length; i++) {
          if (queryList[i].split("=")[0] == "jobPage") {
            this.currentPage = +queryList[i].split("=")[1];
          }
        }
      }
    } else {
      this.currentPage = 1;
    }
    this.getPublisherJobs();
  },

  methods: {
    getPublisherJobs() {
      this.loading = true;
      this.axios
        .post(
          scv_siteUrl + "api/publishers/indexJob/?page=" + this.currentPage,
          {
            publisherId: publisherId,
          },
          {
            headers: {
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          this.jobList = res.data.data;
          this.setPages(res.data.total, res.data.per_page);
          this.loading = false;
        });
    },

    openJobOpportunity(jobId, companyId) {
      window.open(
        `${scv_frontSiteUrl}jobOpportunity?companyId=${companyId}&job=${jobId}`,
        "_blank"
      );
    },

    setPages(total, perPage) {
      let numberOfPages = Math.ceil(total / perPage);
      for (let index = 0; index < numberOfPages; index++) {
        this.pageCount[index] = index + 1;
      }
    },

    onPageChange(pageNumber) {
      window.location.href = this.updateQueryStringParameter(
        "jobPage",
        pageNumber
      );
      return false;
    },

    setGenderName(number) {
      if (number !== undefined) {
        number = number.toString();
        const find = ["1", "2", "3"];
        const replace = ["زن", "مرد", "مرد - زن"];
        for (let i = 0; i < find.length; i++) {
          number = number.replace(new RegExp(find[i], "g"), replace[i]);
        }
        return number;
      }
    },

    updateQueryStringParameter(key, value) {
      let url = window.location.href;
      let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      let separator = url.indexOf("?") !== -1 ? "&" : "?";
      if (url.match(re)) {
        return url.replace(re, "$1" + key + "=" + value + "$2");
      } else {
        return url + separator + key + "=" + value;
      }
    },

    toPersianDigits(number) {
      if (number !== undefined) {
        number = number.toString();
        const find = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
        const replace = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
        for (let i = 0; i < find.length; i++) {
          number = number.replace(new RegExp(find[i], "g"), replace[i]);
        }
        return number;
      }
    },
  },
};
</script>

<style>
.soha-submit-resume {
  direction: rtl;
  box-shadow: 0 0.154rem 0.385rem 0 #8b8b8b;
  border-radius: 0.385rem;
  height: fit-content;
  margin: 0.769rem auto;
  background: white;
}

.soha-job-card {
  border: 0.077rem solid #d2d2d2;
  border-radius: 0.385rem;
  display: flex;
  margin: 1.538rem 0;
}

.soha-job-card:before {
  content: "";
  width: 2%;
  background: #263056;
  border-bottom-right-radius: 0.385rem;
  border-top-right-radius: 0.385rem;
}

.soha-job-card-btn {
  padding: 0.923rem 3.462rem;
  color: white;
  background-color: #263056;
  border-radius: 0.385rem;
  border: 0;
  font-size: 1.2rem;
}

.soha-anchor-tag-style:hover {
  color: white !important;
}

.soha-anchor-tag-style {
  text-decoration: none !important;
}

.soha-job-card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 98%;
  padding: 1.538rem;
}

.soha-job-category-tag {
  background: #d5f4fc;
  padding: 0.385rem;
  border-radius: 0.385rem;
  text-align: center;
}

.soha-job-card-info h2 {
  font-weight: bold;
  font-size: 1.538rem;
  margin-left: 0.769rem;
  display: inline-block;
  color: #263056;
  cursor: pointer;
}

.soha-job-card-info-title {
  display: flex;
  align-items: center;
}

.soha-job-specifications {
  margin-top: 1.538rem;
}

.soha-job-specifications span:not(:first-child) img {
  margin: 0 0.385rem;
}

.soha-job-specifications span:first-child img {
  margin-left: 0.385rem;
}

.soha-job-specifications span:not(:last-child) {
  border-left: 0.154rem solid #d2d2d2;
  padding-left: 0.385rem;
}

.soha-powered-logo {
  width: 2.692rem;
  height: 2.692rem;
  margin-left: 0.769rem;
  margin-top: 0.769rem;
}

.soha-custom-pagination {
  text-align: center;
  min-height: 3.846rem;
  justify-content: center;
  align-items: center;
  display: flex;
}

.soha-custom-pagination a {
  border: 0.077rem solid #263056;
  color: #263056;
  width: 2.308rem;
  height: 2.308rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  margin: 0 0.154rem;
  cursor: pointer;
}

.soha-custom-pagination a:hover {
  color: white;
  background: #263056;
}

.soha-selected-page {
  color: white !important;
  background: #263056;
}

.soha-pagination-offset {
  width: 100%;
  margin: 1.538rem auto;
}
.soha-publisher-pagination {
  display: flex;
  list-style: none;
  border-radius: 0.42rem;
  justify-content: center;
}

.soha-publisher-pagination li:first-child a {
  width: 3.846rem;
  margin: 0 0.385rem;
}
.soha-publisher-pagination li:last-child a {
  width: 3.846rem;
  margin: 0 0.385rem;
}

@media (max-width: 480px) {
  .soha-job-card-action a {
    width: 100%;
    text-align: center;
  }

  .soha-job-specifications span {
    display: block !important;
  }
}

@media (max-width: 768px) {
  .soha-job-card-content {
    display: inline-block;
  }

  .soha-job-card-info-title {
    display: inline-block;
  }

  .soha-job-specifications span {
    display: inline-block;
    margin: 1.154rem 0;
    border: none !important;
  }
  .soha-job-card-action a {
    float: left;
  }

  .soha-job-specifications {
    margin-top: 0;
  }
}

/* soha-tooltip */

/* START soha-tooltip STYLES */
[soha-tooltip] {
  position: relative; /* opinion 1 */
}

/* Applies to all tooltips */
[soha-tooltip]::before,
[soha-tooltip]::after {
  font-family: inherit !important;
  text-transform: none; /* opinion 2 */
  font-size: 0.9em; /* opinion 3 */
  line-height: 1;
  user-select: none;
  pointer-events: none;
  position: absolute;
  display: none;
  opacity: 0;
}
[soha-tooltip]::before {
  content: "";
  border: 0.385rem solid transparent; /* opinion 4 */
  z-index: 1001; /* absurdity 1 */
}
[soha-tooltip]::after {
  content: attr(soha-tooltip); /* magic! */

  /* most of the rest of this is opinion */
  font-family: Helvetica, sans-serif;
  text-align: center;

  /*
    Let the content set the size of the tooltips
    but this will also keep them from being obnoxious
    */
  min-width: 3em;
  max-width: 21em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 1ch 1.5ch;
  border-radius: 0.3ch;
  box-shadow: 0 1em 2em -0.5em rgba(0, 0, 0, 0.35);
  background: #333;
  color: #fff;
  z-index: 1000; /* absurdity 2 */
}

/* Make the tooltips respond to hover */
[soha-tooltip]:hover::before,
[soha-tooltip]:hover::after {
  display: block;
}

/* don't show empty tooltips */
[soha-tooltip=""]::before,
[soha-tooltip=""]::after {
  display: none !important;
}

/* FLOW: UP */
[soha-tooltip]:not([flow])::before,
[soha-tooltip][flow^="up"]::before {
  bottom: 100%;
  border-bottom-width: 0;
  border-top-color: #333;
}
[soha-tooltip]:not([flow])::after,
[soha-tooltip][flow^="up"]::after {
  bottom: calc(100% + 0.385rem);
}
[soha-tooltip]:not([flow])::before,
[soha-tooltip]:not([flow])::after,
[soha-tooltip][flow^="up"]::before,
[soha-tooltip][flow^="up"]::after {
  left: 50%;
  transform: translate(-50%, -0.5em);
}

/* FLOW: DOWN */
[soha-tooltip][flow^="down"]::before {
  top: 100%;
  border-top-width: 0;
  border-bottom-color: #333;
}
[soha-tooltip][flow^="down"]::after {
  top: calc(100% + 0.385rem);
}
[soha-tooltip][flow^="down"]::before,
[soha-tooltip][flow^="down"]::after {
  left: 50%;
  transform: translate(-50%, 0.5em);
}

/* FLOW: LEFT */
[soha-tooltip][flow^="left"]::before {
  top: 50%;
  border-right-width: 0;
  border-left-color: #333;
  left: calc(0em - 0.385rem);
  transform: translate(-0.5em, -50%);
}
[soha-tooltip][flow^="left"]::after {
  top: 50%;
  right: calc(100% + 0.385rem);
  transform: translate(-0.5em, -50%);
}

/* FLOW: RIGHT */
[soha-tooltip][flow^="right"]::before {
  top: 50%;
  border-left-width: 0;
  border-right-color: #333;
  right: calc(0em - 0.385rem);
  transform: translate(0.5em, -50%);
}
[soha-tooltip][flow^="right"]::after {
  top: 50%;
  left: calc(100% + 0.385rem);
  transform: translate(0.5em, -50%);
}

/* KEYFRAMES */
@keyframes tooltips-vert {
  to {
    opacity: 0.9;
    transform: translate(-50%, 0);
  }
}

@keyframes tooltips-horz {
  to {
    opacity: 0.9;
    transform: translate(0, -50%);
  }
}

/* FX All The Things */
[soha-tooltip]:not([flow]):hover::before,
[soha-tooltip]:not([flow]):hover::after,
[soha-tooltip][flow^="up"]:hover::before,
[soha-tooltip][flow^="up"]:hover::after,
[soha-tooltip][flow^="down"]:hover::before,
[soha-tooltip][flow^="down"]:hover::after {
  animation: tooltips-vert 300ms ease-out forwards;
}

[soha-tooltip][flow^="left"]:hover::before,
[soha-tooltip][flow^="left"]:hover::after,
[soha-tooltip][flow^="right"]:hover::before,
[soha-tooltip][flow^="right"]:hover::after {
  animation: tooltips-horz 300ms ease-out forwards;
}

/* soha-tooltip */
</style>
